import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";

import { MdCardMembership, MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaListAlt,
  FaRegCreditCard,
  FaWpforms,
  FaRegCheckCircle,
  FaFileAlt,
  FaUserCheck,
  FaShippingFast,
} from "react-icons/fa";
import {
  FaSearch,
  FaFileUpload,
  FaEdit,
  FaHourglassHalf,
  FaCreditCard,
  FaExchangeAlt,
  FaPercent,
  FaMoneyBillWave,
  FaGlobe,
  FaGift,
  FaChartBar,
} from "react-icons/fa";

import {
  FaMedal,
  FaRegHandshake,
  FaHotel,
  FaReceipt,
  FaLayerGroup,
  FaGlobeAmericas,
  FaPhoneAlt,
  FaUtensils,
  FaGasPump,
} from "react-icons/fa";
import {
  FaMoneyCheckAlt,
  FaClipboardCheck,
  FaBalanceScale,
  FaWallet,
  FaTags,
} from "react-icons/fa";
import {
    FaChartLine,
    FaBriefcase,
    FaPiggyBank,
    FaSuitcaseRolling,
    FaTools,
  } from "react-icons/fa";
  import {
    FaBusinessTime,
    FaHandHoldingUsd,
    FaFolderOpen,
    FaPenNib,
    FaRegClock,
  
  } from "react-icons/fa";
  import {
    FaChartPie,
    FaBalanceScaleRight,
    FaPercentage,
    
    FaFileInvoiceDollar,
    FaUsersCog,
  
  } from "react-icons/fa";
import { FaShieldAlt, FaPlaneDeparture, FaCoins } from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const BusinessCreditCard = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Business")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "What is a rewards credit card?",
      answer:
        "A rewards credit card offers incentives such as points, cashback, or miles for every purchase you make.",
    },
    {
      question: "How do I earn rewards with a rewards credit card?",
      answer:
        "You earn rewards by making purchases with the card, with higher rewards for certain categories.",
    },
    {
      question: "Can I redeem my rewards for cash?",
      answer:
        "Yes, many rewards cards allow you to redeem points for cash or statement credit.",
    },
    {
      question: "What is the sign-up bonus?",
      answer:
        "The sign-up bonus is a reward you receive after meeting a spending threshold within the first few months of using the card.",
    },
    {
      question: "How long does it take to redeem rewards?",
      answer:
        "Redemption can vary, but most programs allow you to redeem rewards immediately or after accumulating a certain number of points.",
    },
    {
      question: "Is there an annual fee for a rewards credit card?",
      answer:
        "Most rewards cards charge an annual fee, but this is often offset by the rewards you earn.",
    },
    {
      question: "Can I use my rewards for travel expenses?",
      answer:
        "Yes, many rewards cards offer travel benefits like airline miles, hotel discounts, or free lounge access.",
    },
    {
      question: "What happens if I don’t pay my balance on time?",
      answer:
        "Late payments may incur interest charges and potentially affect your credit score.",
    },
    {
      question: "Are rewards points transferable?",
      answer:
        "Some credit cards allow you to transfer points to airline or hotel loyalty programs.",
    },
    {
      question: "Do I need a good credit score to apply?",
      answer:
        "Yes, a good credit score is usually required to qualify for a rewards credit card.",
    },
    {
      question: "Can I earn rewards on every purchase?",
      answer:
        "Yes, but the rate of earning rewards may vary depending on the type of purchase.",
    },
    {
      question: "What is the minimum spending requirement to earn rewards?",
      answer:
        "There’s no minimum spending requirement to earn rewards, but you typically need to spend a certain amount to get sign-up bonuses.",
    },
    {
      question: "Are there any foreign transaction fees?",
      answer:
        "Some rewards cards charge foreign transaction fees, while others offer no-fee options.",
    },
    {
      question: "Can I use rewards for online shopping?",
      answer:
        "Many programs allow you to redeem rewards for online shopping through partner retailers.",
    },
    {
      question: "How are rewards points calculated?",
      answer:
        "Points are usually awarded as a percentage of your spending, with bonus points for specific categories.",
    },
    {
      question: "Can I apply for a rewards credit card online?",
      answer: "Yes, most issuers offer an online application process.",
    },
    {
      question: "What happens if I lose my rewards credit card?",
      answer:
        "Contact your card issuer immediately to block the card and prevent unauthorized transactions.",
    },
    {
      question: "Can rewards points expire?",
      answer:
        "Yes, some rewards points may have an expiration date, while others may not.",
    },
    {
      question: "Is there a cap on the rewards I can earn?",
      answer:
        "Some cards may limit the number of points you can earn in specific categories.",
    },
    {
      question: "Can I upgrade my card to a rewards card?",
      answer:
        "Depending on the issuer, you may be able to upgrade your existing card to a rewards credit card.",
    },
    {
      question: "What is a business credit card?",
      answer:
        "A business credit card is a financial tool designed for business-related expenses, offering rewards, expense tracking, and higher credit limits.",
    },
    {
      question:
        "How is a business credit card different from a personal credit card?",
      answer:
        "Business credit cards offer higher credit limits, business-specific rewards, and tools to manage employee expenses, while personal cards are for individual use.",
    },
    {
      question:
        "What are the eligibility requirements for a business credit card?",
      answer:
        "Eligibility includes having a registered business, an EIN, a minimum annual revenue, and a good personal credit score.",
    },
    {
      question: "Can I use a business credit card for personal expenses?",
      answer:
        "It's recommended to only use a business credit card for business-related expenses to avoid complications during tax filing.",
    },
    {
      question:
        "Can employees get their own credit cards with a business account?",
      answer:
        "Yes, many business credit cards allow you to issue employee cards with predefined spending limits.",
    },
    {
      question: "What are the rewards on business credit cards?",
      answer:
        "Rewards can include cashback, travel points, discounts on office supplies, and more, depending on the card and the business category.",
    },
    {
      question: "Do business credit cards offer travel benefits?",
      answer:
        "Many business credit cards offer travel perks such as hotel discounts, airport lounge access, and travel insurance.",
    },
    {
      question: "What’s the credit limit for a business credit card?",
      answer:
        "Business credit cards generally offer higher credit limits than personal cards, based on the business's financial strength.",
    },
    {
      question: "Can I carry a balance on my business credit card?",
      answer:
        "Yes, but carrying a balance may incur interest charges. It's important to pay off your balance on time to avoid additional fees.",
    },
    {
      question: "How do business credit cards help build credit?",
      answer:
        "Using a business credit card responsibly and making timely payments helps establish and build your business credit score.",
    },
    {
      question: "Are there any fees for business credit cards?",
      answer:
        "Most business credit cards have annual fees, but these are often outweighed by the benefits and rewards offered.",
    },
    {
      question: "Can I get a business credit card if my business is new?",
      answer:
        "Yes, though some issuers may require your business to be at least six months old.",
    },
    {
      question: "What happens if my business card is lost or stolen?",
      answer:
        "Contact your card issuer immediately to report the loss and prevent unauthorized transactions.",
    },
    {
      question: "Can I get a business credit card with no annual fee?",
      answer:
        "Some business credit cards do offer no annual fee options, but these cards may offer fewer perks and rewards.",
    },
    {
      question: "How can I track my business spending with a credit card?",
      answer:
        "Most business credit cards offer detailed reports and tools to categorize and monitor your business expenses.",
    },
    {
      question:
        "Can I apply for a business credit card if I am a sole proprietor?",
      answer:
        "Yes, sole proprietors can apply for a business credit card using their personal information and business income.",
    },
    {
      question: "What is the best business credit card for travel?",
      answer:
        "Cards offering travel rewards, such as miles and hotel points, are ideal for frequent business travelers.",
    },
    {
      question: "Can I use my business credit card internationally?",
      answer:
        "Many business credit cards allow for international transactions, but you may want to check for foreign transaction fees.",
    },
    {
      question: "How do I redeem business rewards points?",
      answer:
        "Rewards can be redeemed for travel, statement credits, merchandise, or other rewards depending on the card issuer.",
    },
    {
      question: "Can I convert my personal credit card into a business card?",
      answer:
        "Some issuers allow you to convert a personal card to a business card, but this depends on the card issuer’s policies.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  const steps = [
    {
      icon: <FaBusinessTime className="h-6 w-6 text-blue-600" />,
      title: "Assess Your Business Needs",
      description:
        "  Evaluate your business spending patterns and identify the types of benefits you need, such as travel rewards, cashback, or purchase protection.",
    },
    {
      icon: <FaHandHoldingUsd className="h-6 w-6 text-amber-500" />,
      title: " Choose the Right Card",
      description:
        "  Research and compare different business credit card options to find one that aligns with your needs and offers the best rewards, low-interest rates, and other relevant features.",
    },
    {
      icon: <FaFolderOpen className="h-6 w-6 text-purple-600" />,
      title: "Prepare Your Business Information",
      description:
        "  Gather necessary business documents, including your business license, tax identification number, and annual revenue details.",
    },
    {
      icon: <FaPenNib className="h-6 w-6 text-teal-500" />,
      title: "Submit Your Application ",
      description:
        "  Fill out the online or offline application form, providing accurate information about your business, its financial status, and key employees.",
    },

    {
      icon: <FaRegClock className="h-6 w-6 text-pink-500" />,
      title: " Wait for Approval",
      description:
        "The issuer will assess your application, reviewing the business’s credit history, financial stability, and the owner’s personal credit score.",
    },

    {
      icon: <FaCreditCard className="h-6 w-6 text-green-500" />,
      title: "Receive Your Card",
      description:
        "  Once approved, the business credit card will be sent to your registered business address. Follow the activation instructions and start using the card for your business expenses.",
    },
  ];
  const benefits = [
    {
      icon: <FaBriefcase className="text-3xl text-amber-600" />,
      title: "Separation of Personal and Business Expenses",
      description:
        " A business credit card helps you easily track and manage business-related expenses separately from personal spending, simplifying accounting and tax filing.",
    },

    {
      icon: <FaChartLine className="text-3xl text-purple-600" />,
      title: "Higher Credit Limits",
      description:
        "   Business credit cards generally offer higher credit limits compared to personal cards, giving you the flexibility to manage larger expenses and cash flow needs.",
    },
    {
      icon: <FaReceipt className="text-3xl text-pink-500" />,
      title: "Expense Tracking and Reporting",
      description:
        " These cards provide advanced tracking tools and generate detailed reports, which can help you monitor your business’s spending patterns and budget more effectively.",
    },
    {
      icon: <FaGift className="text-3xl text-yellow-500" />,
      title: "Rewards and Cashback",
      description:
        "  Many business credit cards offer rewards or cashback on categories like office supplies, travel, and dining. These rewards can be redeemed for travel, gift cards, or statement credits, providing additional savings.",
    },

    {
      icon: <FaPiggyBank className="text-3xl text-red-500" />,
      title: "  Building Business Credit",
      description:
        "  By using a business credit card and making timely payments, you can establish and improve your business credit score, which can be crucial for securing business loans in the future.",
    },
    {
        icon: <FaTools  className="text-3xl text-red-500" />,
        title: "Expense Management Tools",
        description:
          "  Many business credit cards come with online tools and apps to help you monitor individual employee expenses, set spending limits, and manage recurring payments.",
      },
      {
        icon: <FaSuitcaseRolling className="text-3xl text-red-500" />,
        title: "  Access to Travel and Business Perks",
        description:
          "  Some business credit cards offer perks like airport lounge access, hotel discounts, and travel insurance, making them ideal for business travelers.",
      },
  ];

  const factors = [
    {
      icon: FaChartPie,
      title: "Reward Programs",
      desc: "   Look for a business credit card that offers a rewards program that suits your business needs. Whether it’s cashback, travel points, or office supply rebates, ensure the card rewards you in categories relevant to your busines.",
    },
    {
      icon: FaBalanceScaleRight,
      title: " Annual Fee vs. Benefits",
      desc: "  Consider the card’s annual fee in relation to the benefits offered. For businesses that spend significantly, a higher annual fee may be worthwhile if the card offers substantial rewards and other perks.",
    },

    {
      icon: FaPercentage,
      title: "Interest Rates",
      desc: "  Choose a card with competitive interest rates to help manage your business’s cash flow efficiently. Low interest on purchases and cash advances is essential for maintaining financial health.",
    },
    {
      icon: FaCreditCard,
      title: "Credit Limit",
      desc: "   Ensure the card offers a credit limit that meets your business’s spending requirements. Some cards offer flexible limits based on your business's financial strength.",
    },
    {
      icon:  FaFileInvoiceDollar,
      title: "Expense Management Tools",
      desc: "   Opt for cards that offer robust expense tracking, reporting tools, and integration with accounting software, to streamline financial management.",
    },
    {
      icon: FaUsersCog,
      title: "Employee Cards",
      desc: "  Some business credit cards allow you to issue additional cards for your employees. Look for cards that offer the ability to set individual spending limits for each employee.",
    },
    {
      icon: FaMedal,
      title: "Sign-Up Bonuses",
      desc: "  Many business credit cards offer attractive sign-up bonuses, which can give your business an immediate financial boost. Make sure to check the bonus requirements and any associated spending thresholds.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Best Premium Credit Cards in India 2024 - Exclusive Benefits
        </title>
        <meta
          name="description"
          content="Best Premium Credit Cards in India - Check Best Premium Credit Cards Available in India. Compare & Apply now for the Most Prestigious with Benefits."
        />
        <meta
          name="keywords"
          content="premium credit cards, american express platinum charge card, axis bank premium credit card, sbi premium credit card, hdfc bank premium credit card, icici bank premium credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/best-premium-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Business Credit Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-2 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          <Link to="/credit-card/best-premium-credit-card"  className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group">
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                    <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                    <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span className="relative flex items-center"><MdStars className="mr-1 text-black text-2xl" /> <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">Premium</span></span>
                    </Link>
                    <Link
                    to="/credit-card/reward-credit-card"
                    className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                  >
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span className="relative flex items-center">
                      <FaGift className="mr-1 text-black text-2xl" />{" "}
                      <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                      Reward
                      </span>
                    </span>
                  </Link>
                
                  <Link
                    to="/credit-card/lifestyle-credit-card"
                    className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                  >
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span className="relative flex items-center">
                      <MdCardMembership className="mr-1 text-black text-2xl" />{" "}
                      <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        LifeStyle
                      </span>
                    </span>
                  </Link>
        </div>
        <h1 className="text-center font-bold text-5xl my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[350px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                                <h2 className="text-center font-medium pt-5 text-lg">
                                                  <span className="font-semibold text-white">816 people</span>{" "}
                                                  are on call with our advisors right now
                                                </h2>
                                              </div> */}
              <div className="w-full mx-auto">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-[80%] mx-auto ">
                    <img
                      src="/assets/ppp.png"
                      alt="Advertisement"
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  </div>
                </Link>
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                    Know your advisor
                                                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            What is a Business Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A Business Credit Card is a financial tool specifically designed to
            meet the needs of small and medium-sized businesses, as well as
            large corporations. These cards allow businesses to separate
            personal and business expenses, streamline cash flow management, and
            enjoy rewards or benefits tailored to business-related spending.
            Business credit cards offer unique features, such as higher credit
            limits, expense tracking tools, and enhanced reporting, to help
            business owners manage their finances effectively. They also provide
            the convenience of making purchases, paying for business expenses,
            and building business credit, which can be crucial for future
            growth.
          </p>
        </div>
      </div>

      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          📝 How to Apply for a Business Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a Premium Credit Card is an easy yet
          eligibility-dependent process. Here's how to go about it:
        </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for a Business Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Proof of Business Identity
                </span>
                <span>
                  {" "}
                  Business registration certificate, partnership agreement, or
                  LLC documentation.
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Employer Identification Number (EIN)
                </span>
                <span>
                  {" "}
                  A unique number assigned to your business by the IRS for tax
                  purposes.
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Personal Identification
                </span>
                <span>
                  {" "}
                  Personal ID proof of the business owner(s), such as a passport
                  or driver’s license.
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Business Financials
                </span>
                <span>
                  {" "}
                  Tax returns, profit and loss statements, balance sheets, and
                  annual business revenue reports.
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Business Address Proof
                </span>
                <span>
                  {" "}
            Utility bills, lease agreements, or bank statements showing the registered business address.
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-3xl font-extrabold text-gray-800 dark:text-white">
              Eligibility Required to Get a Business Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  {" "}
                  Business Type
                </span>
                <span>
                  {" "}
                  Can be a sole proprietorship, partnership, LLC, or corporation.

                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Business Age{" "}
                </span>
                <span> Most issuers require your business to be at least 6 months to 1 year old.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Minimum Annual Revenue
                </span>
                <span>  A certain level of business revenue, typically ₹1 lakh or more annually (may vary by issuer).
</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Credit Score
                </span>
                <span>
                  {" "}
                  While business credit scores are considered, the owner's personal credit score (usually 650 or above) may also play a role in approval.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Tax Identification Number (TIN)
                </span>
                <span>
                  {" "}
                  A TIN or Employer Identification Number (EIN) is often required for businesses to apply.

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto mt-4">
        <h2 className="text-3xl font-semibold text-gray-800 text-center mb-10">
        Benefits of a Business Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">
        How to Choose the Best Business Credit Card - Key Factors to Consider{" "}
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-12 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-3xl font-bold text-center mb-6">
        Why Opt for a Business Credit Card?
        </h2>

        <p className="text-base md:text-md text-center mb-14 max-w-4xl mx-auto text-gray-800">
        A business credit card is essential for entrepreneurs, small business owners, and large corporations who wish to manage their expenses efficiently while earning rewards. These cards allow you to keep your business transactions separate from personal finances, provide access to higher credit limits, and offer tools to manage employee spending. If your business regularly incurs travel, office supply, or advertising expenses, a business credit card can help you save on costs, while providing a streamlined way to track and report these expenses. A business credit card can also improve your credit profile and make it easier to secure loans or other financing in the future.
        </p>

        {/* Comparison Table */}
        <h3 className="text-3xl font-semibold text-center mb-8">
        Comparison Between Business Credit Cards and Personal Credit Cards
        </h3>
        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Eligibility",
                  "Requires business details, revenue, and EIN",
                  "Based on personal credit score and income",
                ],
                [
                  "Credit Limit",
                  "Higher limits, often based on business revenue",
                  "Generally lower limits",
                ],
                [
                  "Rewards",
                  "Custom rewards for business expenses like office supplies, travel",
                  "Rewards for general purchases",
                ],
                [
                  "Perks",
                  "Business-related perks such as travel discounts, employee cards",
                  "Basic perks like cash back or points for everyday spending",
                ],
                [
                  "Expenses Management",
                  "Advanced tools for tracking and managing business expenses",
                  "Basic tracking of personal spending",
                ],
                [
                    "Annual Fees",
                    "Often higher, but can be outweighed by business benefits",
                    "Typically lower but varies depending on the card",
                  ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">
                      Business Credit Car:
                      </span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Personal Credit Card:</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                    Business Credit Car
                    </th>
                    <th className="px-4 py-3 font-semibold">
                    Personal Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                     [
                        "Eligibility",
                        "Requires business details, revenue, and EIN",
                        "Based on personal credit score and income",
                      ],
                      [
                        "Credit Limit",
                        "Higher limits, often based on business revenue",
                        "Generally lower limits",
                      ],
                      [
                        "Rewards",
                        "Custom rewards for business expenses like office supplies, travel",
                        "Rewards for general purchases",
                      ],
                      [
                        "Perks",
                        "Business-related perks such as travel discounts, employee cards",
                        "Basic perks like cash back or points for everyday spending",
                      ],
                      [
                        "Expenses Management",
                        "Advanced tools for tracking and managing business expenses",
                        "Basic tracking of personal spending",
                      ],
                      [
                          "Annual Fees",
                          "Often higher, but can be outweighed by business benefits",
                          "Typically lower but varies depending on the card",
                        ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BusinessCreditCard;
